export default class Common {
    static get baseUrl() {
        return `${window.location.protocol}//${window.location.host}`;
    }
    static showLoader() {
        document.getElementById('LoadingAnimation').style.display = 'block';
    }
    static hideLoader() {
        document.getElementById('LoadingAnimation').style.display = 'none';
    }
    static getUrl(url) {
        return new Promise((resolve, reject) => {
            fetch(url).then(response => {
                resolve(response);
            }).catch(e => reject(e));
            //$.get(url, response => {
            //    resolve(response)
            //}).fail(e => reject(e));
        });
    }
    static postFormData(url, form, callback, progressSelector) {
        Common.showLoader();
        callback = callback || eval('master_callback');
        var formData;
        if (form instanceof Blob) {
            formData = new FormData();
            formData.append("imageBlob", form);
        }
        else {
            formData = new FormData(form);
        }
        $.ajax({
            url: url,
            type: 'POST',
            data: formData,
            cache: false,
            contentType: false,
            processData: false,
            success: function (result) {
                callback(result);
                Common.hideLoader();
            },
            error: function (result) {
                eval('master_callback(result)');
                Common.hideLoader();
                if (progressSelector) {
                    $(progressSelector).text("Upload Failed.");
                }
            },
            xhr: function () {
                if (progressSelector) {
                    var myXhr = $.ajaxSettings.xhr();
                    if (myXhr.upload) {
                        myXhr.upload.addEventListener('progress', function progress(e) {
                            if (e.lengthComputable) {
                                let max = e.total;
                                let current = e.loaded;
                                var Percentage = (current * 100) / max;
                                $(progressSelector).text("Uploading...(" + Percentage + "%)");
                            }
                        }, false);
                    }
                    return myXhr;
                }
            }
        });
    }
    static postData(url, requestData, callback = null) {
        Common.showLoader();
        callback = callback || eval('master_callback');
        return new Promise((resolve, reject) => {
            $.ajax({
                url,
                type: "POST",
                method: "POST",
                data: JSON.stringify(requestData),
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                success: (r) => {
                    Common.hideLoader();
                    resolve(r);
                },
                error: (e) => {
                    Common.hideLoader();
                    reject(e);
                }
            });
        });
    }
    static postDataAsForm(url, requestData) {
        Common.showLoader();
        return new Promise((resolve, reject) => {
            $.post(url, requestData, function (r) {
                Common.hideLoader();
                resolve(r);
            }, 'json').fail(function (jq, status, e) {
                Common.hideLoader();
                reject(e);
            });
        });
    }
    static formatSize(bytes) {
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes == 0)
            return '0 Byte';
        var i = parseInt((Math.floor(Math.log(bytes) / Math.log(1024))).toString());
        return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
    }
    static secondsToHourMinute(seconds) {
        seconds = Number(seconds);
        if (seconds == 0 || seconds == -1)
            return "0 Sec";
        var h = Math.floor(seconds / 3600);
        var m = Math.floor(seconds % 3600 / 60);
        var s = Math.floor(seconds % 3600 % 60);
        var hDisplay = h > 0 ? h + (h == 1 ? " Hr " : " Hr ") : "";
        var mDisplay = m > 0 ? m + (m == 1 ? " Min " : " Min ") : "";
        var sDisplay = s > 0 ? s + (s == 1 ? " Sec" : " Sec") : "";
        return hDisplay + mDisplay + sDisplay;
    }
    static jsonToSeconds(s) {
        if (typeof s === "undefined" || s == null || s == "")
            return 0;
        if (s.search("Date") > -1) { //data from server: "/Date(xxxxx)/"
            var cd = new Date();
            s = s.replace("/Date(", "").replace(")", "");
            var s2 = "new Date(" + (parseFloat(s)) + ")";
            var d = eval(s2);
        }
        else { // in format 'MM/DD/YYYY'
            let sp = s.indexOf("-") > -1 ? s.split("-") : s.split("/");
            let d = new Date(sp[2], sp[0] - 1, sp[1], 0, 0, 0, 0);
        }
        if (d.getYear() == 1969 || d.getYear() == 69) {
            d = new Date(1970, 0, 1, 12, 0, 0, 0);
        }
        return d.getTime();
    }
    static getTransition(animation) {
        let outClass = '', inClass = '';
        let transition = parseInt(animation);
        switch (transition) {
            case 0:
                outClass = 'pt-page-fadeOut';
                inClass = 'pt-page-fadeIn';
                break;
            case 1:
                outClass = 'pt-page-moveToLeft';
                inClass = 'pt-page-moveFromRight';
                break;
            case 2:
                outClass = 'pt-page-moveToRight';
                inClass = 'pt-page-moveFromLeft';
                break;
            case 3:
                outClass = 'pt-page-moveToTop';
                inClass = 'pt-page-moveFromBottom';
                break;
            case 4:
                outClass = 'pt-page-moveToBottom';
                inClass = 'pt-page-moveFromTop';
                break;
            case 5:
                outClass = 'pt-page-fade';
                inClass = 'pt-page-moveFromRight pt-page-ontop';
                break;
            case 6:
                outClass = 'pt-page-fade';
                inClass = 'pt-page-moveFromLeft pt-page-ontop';
                break;
            case 7:
                outClass = 'pt-page-fade';
                inClass = 'pt-page-moveFromBottom pt-page-ontop';
                break;
            case 8:
                outClass = 'pt-page-fade';
                inClass = 'pt-page-moveFromTop pt-page-ontop';
                break;
            case 9:
                outClass = 'pt-page-moveToLeftFade';
                inClass = 'pt-page-moveFromRightFade';
                break;
            case 10:
                outClass = 'pt-page-moveToRightFade';
                inClass = 'pt-page-moveFromLeftFade';
                break;
            case 11:
                outClass = 'pt-page-moveToTopFade';
                inClass = 'pt-page-moveFromBottomFade';
                break;
            case 12:
                outClass = 'pt-page-moveToBottomFade';
                inClass = 'pt-page-moveFromTopFade';
                break;
            case 13:
                outClass = 'pt-page-moveToLeftEasing pt-page-ontop';
                inClass = 'pt-page-moveFromRight';
                break;
            case 14:
                outClass = 'pt-page-moveToRightEasing pt-page-ontop';
                inClass = 'pt-page-moveFromLeft';
                break;
            case 15:
                outClass = 'pt-page-moveToTopEasing pt-page-ontop';
                inClass = 'pt-page-moveFromBottom';
                break;
            case 16:
                outClass = 'pt-page-moveToBottomEasing pt-page-ontop';
                inClass = 'pt-page-moveFromTop';
                break;
            case 17:
                outClass = 'pt-page-scaleDown';
                inClass = 'pt-page-moveFromRight pt-page-ontop';
                break;
            case 18:
                outClass = 'pt-page-scaleDown';
                inClass = 'pt-page-moveFromLeft pt-page-ontop';
                break;
            case 19:
                outClass = 'pt-page-scaleDown';
                inClass = 'pt-page-moveFromBottom pt-page-ontop';
                break;
            case 20:
                outClass = 'pt-page-scaleDown';
                inClass = 'pt-page-moveFromTop pt-page-ontop';
                break;
            case 21:
                outClass = 'pt-page-scaleDown';
                inClass = 'pt-page-scaleUpDown pt-page-delay300';
                break;
            case 22:
                outClass = 'pt-page-scaleDownUp';
                inClass = 'pt-page-scaleUp pt-page-delay300';
                break;
            case 23:
                outClass = 'pt-page-moveToLeft pt-page-ontop';
                inClass = 'pt-page-scaleUp';
                break;
            case 24:
                outClass = 'pt-page-moveToRight pt-page-ontop';
                inClass = 'pt-page-scaleUp';
                break;
            case 25:
                outClass = 'pt-page-moveToTop pt-page-ontop';
                inClass = 'pt-page-scaleUp';
                break;
            case 26:
                outClass = 'pt-page-moveToBottom pt-page-ontop';
                inClass = 'pt-page-scaleUp';
                break;
            case 27:
                outClass = 'pt-page-scaleDownCenter';
                inClass = 'pt-page-scaleUpCenter pt-page-delay400';
                break;
            case 28:
                outClass = 'pt-page-rotateRightSideFirst';
                inClass = 'pt-page-moveFromRight pt-page-delay200 pt-page-ontop';
                break;
            case 29:
                outClass = 'pt-page-rotateLeftSideFirst';
                inClass = 'pt-page-moveFromLeft pt-page-delay200 pt-page-ontop';
                break;
            case 30:
                outClass = 'pt-page-rotateTopSideFirst';
                inClass = 'pt-page-moveFromTop pt-page-delay200 pt-page-ontop';
                break;
            case 31:
                outClass = 'pt-page-rotateBottomSideFirst';
                inClass = 'pt-page-moveFromBottom pt-page-delay200 pt-page-ontop';
                break;
            case 32:
                outClass = 'pt-page-flipOutRight';
                inClass = 'pt-page-flipInLeft pt-page-delay500';
                break;
            case 33:
                outClass = 'pt-page-flipOutLeft';
                inClass = 'pt-page-flipInRight pt-page-delay500';
                break;
            case 34:
                outClass = 'pt-page-flipOutTop';
                inClass = 'pt-page-flipInBottom pt-page-delay500';
                break;
            case 35:
                outClass = 'pt-page-flipOutBottom';
                inClass = 'pt-page-flipInTop pt-page-delay500';
                break;
            case 36:
                outClass = 'pt-page-rotateFall pt-page-ontop';
                inClass = 'pt-page-scaleUp';
                break;
            case 37:
                outClass = 'pt-page-rotateOutNewspaper';
                inClass = 'pt-page-rotateInNewspaper pt-page-delay500';
                break;
            case 38:
                outClass = 'pt-page-rotatePushLeft';
                inClass = 'pt-page-moveFromRight';
                break;
            case 39:
                outClass = 'pt-page-rotatePushRight';
                inClass = 'pt-page-moveFromLeft';
                break;
            case 40:
                outClass = 'pt-page-rotatePushTop';
                inClass = 'pt-page-moveFromBottom';
                break;
            case 41:
                outClass = 'pt-page-rotatePushBottom';
                inClass = 'pt-page-moveFromTop';
                break;
            case 42:
                outClass = 'pt-page-rotatePushLeft';
                inClass = 'pt-page-rotatePullRight pt-page-delay180';
                break;
            case 43:
                outClass = 'pt-page-rotatePushRight';
                inClass = 'pt-page-rotatePullLeft pt-page-delay180';
                break;
            case 44:
                outClass = 'pt-page-rotatePushTop';
                inClass = 'pt-page-rotatePullBottom pt-page-delay180';
                break;
            case 45:
                outClass = 'pt-page-rotatePushBottom';
                inClass = 'pt-page-rotatePullTop pt-page-delay180';
                break;
            case 46:
                outClass = 'pt-page-rotateFoldLeft';
                inClass = 'pt-page-moveFromRightFade';
                break;
            case 47:
                outClass = 'pt-page-rotateFoldRight';
                inClass = 'pt-page-moveFromLeftFade';
                break;
            case 48:
                outClass = 'pt-page-rotateFoldTop';
                inClass = 'pt-page-moveFromBottomFade';
                break;
            case 49:
                outClass = 'pt-page-rotateFoldBottom';
                inClass = 'pt-page-moveFromTopFade';
                break;
            case 50:
                outClass = 'pt-page-moveToRightFade';
                inClass = 'pt-page-rotateUnfoldLeft';
                break;
            case 51:
                outClass = 'pt-page-moveToLeftFade';
                inClass = 'pt-page-rotateUnfoldRight';
                break;
            case 52:
                outClass = 'pt-page-moveToBottomFade';
                inClass = 'pt-page-rotateUnfoldTop';
                break;
            case 53:
                outClass = 'pt-page-moveToTopFade';
                inClass = 'pt-page-rotateUnfoldBottom';
                break;
            case 54:
                outClass = 'pt-page-rotateRoomLeftOut pt-page-ontop';
                inClass = 'pt-page-rotateRoomLeftIn';
                break;
            case 55:
                outClass = 'pt-page-rotateRoomRightOut pt-page-ontop';
                inClass = 'pt-page-rotateRoomRightIn';
                break;
            case 56:
                outClass = 'pt-page-rotateRoomTopOut pt-page-ontop';
                inClass = 'pt-page-rotateRoomTopIn';
                break;
            case 57:
                outClass = 'pt-page-rotateRoomBottomOut pt-page-ontop';
                inClass = 'pt-page-rotateRoomBottomIn';
                break;
            case 58:
                outClass = 'pt-page-rotateCubeLeftOut pt-page-ontop';
                inClass = 'pt-page-rotateCubeLeftIn';
                break;
            case 59:
                outClass = 'pt-page-rotateCubeRightOut pt-page-ontop';
                inClass = 'pt-page-rotateCubeRightIn';
                break;
            case 60:
                outClass = 'pt-page-rotateCubeTopOut pt-page-ontop';
                inClass = 'pt-page-rotateCubeTopIn';
                break;
            case 61:
                outClass = 'pt-page-rotateCubeBottomOut pt-page-ontop';
                inClass = 'pt-page-rotateCubeBottomIn';
                break;
            case 62:
                outClass = 'pt-page-rotateCarouselLeftOut pt-page-ontop';
                inClass = 'pt-page-rotateCarouselLeftIn';
                break;
            case 63:
                outClass = 'pt-page-rotateCarouselRightOut pt-page-ontop';
                inClass = 'pt-page-rotateCarouselRightIn';
                break;
            case 64:
                outClass = 'pt-page-rotateCarouselTopOut pt-page-ontop';
                inClass = 'pt-page-rotateCarouselTopIn';
                break;
            case 65:
                outClass = 'pt-page-rotateCarouselBottomOut pt-page-ontop';
                inClass = 'pt-page-rotateCarouselBottomIn';
                break;
            case 66:
                outClass = 'pt-page-rotateSidesOut';
                inClass = 'pt-page-rotateSidesIn pt-page-delay200';
                break;
            case 67:
                outClass = 'pt-page-rotateSlideOut';
                inClass = 'pt-page-rotateSlideIn';
                break;
            case 68:
                outClass = 'pt-page-fadeOut';
                inClass = 'pt-page-fadeIn';
                break;
        }
        return { outClass, inClass };
    }
    static makeDatatableResizable(selector, timeout = 1500) {
        timeout = timeout || 1500;
        selector = selector || $("body");
        $("div.JCLRgrips", selector).remove();
        var DisableColumns = [];
        setTimeout(() => {
            var dt = $("table.b-table th", selector);
            dt.each(function (idx) {
                var html = $(this).html().trim();
                if (html == "" || html.indexOf("checkbox") > -1 || html.indexOf("img") > -1) {
                    if (idx == dt.length - 1)
                        idx--;
                    DisableColumns.push(idx);
                }
                if (html.indexOf("checkbox") > -1)
                    $(this).css("overflow", "visible");
            });
            var resizeMode = "fit";
            if ($("table.b-table", selector).attr("data-resize-mode") != undefined) {
                resizeMode = $("table.b-table", selector).attr("data-resize-mode");
            }
            $("table.b-table", selector).colResizable({
                liveDrag: true,
                disabledColumns: DisableColumns,
                headerOnly: true,
                partialRefresh: true,
                minWidth: 25,
                resizeMode: resizeMode
            });
        }, timeout);
    }
}
Common.codigoProdUrl = 'https://codigo.gocodigo.net/';
